<template>
  <div>
    <div class="store-title-container">
      <div class="left-btn-container">
        <span class="store-title">企业主页设置</span>
        <eui-btn type="text" @click="() => goPath()">主页预览</eui-btn>
      </div>
      <eui-btn v-if="auditStatus" type="text" @click="() => goPath('/storeAudit')">查看审核</eui-btn>
    </div>
    <div style="min-height: 1226px">
      <template v-if="auditStatus === 2 || auditStatus === 3 || auditStatus === 0">
        <div class="store-container">
          <div class="title-wrap">
            <h2 class="title">上传企业视频介绍</h2>
            <div class="title-tips">
              <el-popover placement="right" trigger="hover" popper-class="store-show">
                <img src="@/assets/img/store/video.jpg" alt="" height="320" />
                <div slot="reference">
                  <eui-icon icon="eicon-problem-normal" font-size="18px" color="#C5C5C5"></eui-icon>
                  <span>示例</span>
                </div>
              </el-popover>
            </div>
          </div>
          <eui-upload
            ref="euiUpload1"
            class="video-upload"
            key-name="auditorCertificate"
            :file-list="enterpriseInfo.videoFileList"
            :action="videoFileUpload"
            :headers="headers"
            :limit-file-size="20"
            :limit="1"
            show-file-list
            text="上传视频"
            accept=".mp4,.avi,.mpeg,.wmv,.flv,.mov,.mkv,.rmvb,.3gp"
            @handleSuccess="videoSuccess"
            @handleError="videoError"
          ></eui-upload>
          <div class="message-tips">提示：最多上传 1个视频文件，大小不能超过 20M。</div>
        </div>

        <div class="store-container">
          <div class="title-wrap">
            <h2 class="title">上传企业宣传图片</h2>
            <div class="title-tips">
              <el-popover placement="right" trigger="hover" popper-class="store-show">
                <img src="@/assets/img/store/img.jpg" alt="" height="320" />
                <div slot="reference">
                  <eui-icon icon="eicon-problem-normal" font-size="18px" color="#C5C5C5"></eui-icon>
                  <span>示例</span>
                </div>
              </el-popover>
            </div>
          </div>
          <eui-upload
            ref="euiUploadSix"
            list-type="picture-card"
            class="store-single"
            :class="{ 'no-upload': enterpriseInfo.slidesFileList.length >= 6 }"
            :file-list="enterpriseInfo.slidesFileList"
            :action="zoneConfigurationImageUpload"
            :headers="headers"
            accept=".png,.jpg,.jpeg"
            show-file-list
            :limit-file-size="5"
            :limit="6"
            @handleSuccess="slidesSuccess"
          ></eui-upload>
          <div class="message-tips">提示：最多上传 6个图片文件，单个大小不能超过 5M。</div>
        </div>

        <div class="store-container">
          <div class="title-wrap">
            <h2 class="title">企业简介</h2>
            <div class="title-tips">
              <el-popover placement="right" trigger="hover" popper-class="store-show">
                <img src="@/assets/img/store/desc.jpg" alt="" height="320" />
                <div slot="reference">
                  <eui-icon icon="eicon-problem-normal" font-size="18px" color="#C5C5C5"></eui-icon>
                  <span>示例</span>
                </div>
              </el-popover>
            </div>
          </div>
          <el-input
            v-model="enterpriseInfo.enterpriseProfile"
            type="textarea"
            placeholder="请输入公司简介"
            maxlength="2000"
            show-word-limit
            :rows="4"
          ></el-input>
          <!-- <div class="title-wrap"></div>
      <el-input v-model="enterpriseInfo.vrUrl" placeholder="请输入VR观企地址，以http：//开头"></el-input> -->
        </div>
        <div class="store-container">
          <div class="title-wrap">
            <h2 class="title">VR地址</h2>
          </div>
          <el-input v-model="enterpriseInfo.vrUrl" placeholder="请输入VR观企地址，以http开头"></el-input>
        </div>
        <div class="store-container">
          <div class="title-wrap">
            <h2 class="title">企业资质</h2>
          </div>
          <div class="message-wrapper">
            <div class="message-left">提示：</div>
            <div class="message-content">
              <p>请确保您充分知悉并符合以下基本条件及说明：</p>
              <p>1.提交的信息真实，证明文件有效。</p>
              <p>2.易派客有权对上传的文件进行不定期抽查，以核实真实性、合法性和效力状态。</p>
              <p>
                3.上传的证书需不侵犯他人知识产权，需按自有资质要求上传，正确的数据，合法的数据，如有法律分险，需自行承担。
              </p>
              <p>4.每一项资质最多上传50个文件，单个文件最大支持20M。</p>
            </div>
          </div>
          <EnterpriseInfo
            ref="enterpriseInfo"
            :tabs="enterpriseInfo.tabsList"
            :status="auditStatus"
            @getIndex="getIndex"
          ></EnterpriseInfo>
          <div class="message-tips">{{ messages[currentIndex] }}</div>
        </div>

        <div class="store-container">
          <div class="title-wrap">
            <h2 class="title">核心产品</h2>
          </div>
          <ProductConfig
            ref="productConfig"
            :pane-list="enterpriseInfo.paneList"
            @onSetting="onSetting"
          ></ProductConfig>
        </div>
      </template>
      <template v-if="auditStatus === 1">
        <div class="store-container">
          <div class="title-wrap">
            <h2 class="title">上传企业视频介绍</h2>
            <div class="title-tips">
              <el-popover placement="right" trigger="hover" popper-class="store-show">
                <img src="@/assets/img/store/video.jpg" alt="" height="320" />
                <div slot="reference">
                  <eui-icon icon="eicon-problem-normal" font-size="18px" color="#C5C5C5"></eui-icon>
                  <span>示例</span>
                </div>
              </el-popover>
            </div>
          </div>
          <div v-if="enterpriseInfo.videoFileList.length > 0 && enterpriseInfo.videoFileList[0].url">
            <!-- 先有url 在有html 播放就没问题 -->
            <video id="video-modal" width="200" height="120" controls loop style="object-fit: cover">
              <source :src="enterpriseInfo.videoFileList[0].url" />
            </video>
          </div>
        </div>

        <div class="store-container">
          <div class="title-wrap">
            <h2 class="title">上传企业宣传图片</h2>
            <div class="title-tips">
              <el-popover placement="right" trigger="hover" popper-class="store-show">
                <img src="@/assets/img/store/img.jpg" alt="" height="320" />
                <div slot="reference">
                  <eui-icon icon="eicon-problem-normal" font-size="18px" color="#C5C5C5"></eui-icon>
                  <span>示例</span>
                </div>
              </el-popover>
            </div>
          </div>
          <div>
            <el-image
              v-for="item in enterpriseInfo.slidesFileList"
              :key="item.id"
              style="width: 100px; height: 100px; margin-right: 10px"
              :src="item.url"
              :preview-src-list="[item.url]"
            ></el-image>
          </div>
        </div>

        <div class="store-container">
          <div class="title-wrap">
            <h2 class="title">企业简介</h2>
            <div class="title-tips">
              <el-popover placement="right" trigger="hover" popper-class="store-show">
                <img src="@/assets/img/store/desc.jpg" alt="" height="320" />
                <div slot="reference">
                  <eui-icon icon="eicon-problem-normal" font-size="18px" color="#C5C5C5"></eui-icon>
                  <span>示例</span>
                </div>
              </el-popover>
            </div>
          </div>
          <div>
            <el-scrollbar ref="scrollbar" style="height: 148px">
              <div class="text">
                {{ enterpriseInfo.enterpriseProfile }}
              </div>
            </el-scrollbar>
          </div>
        </div>
        <div class="store-container">
          <div class="title-wrap">
            <h2 class="title">VR地址</h2>
          </div>
          <div>{{ enterpriseInfo.vrUrl }}</div>
        </div>
        <div class="store-container">
          <div class="title-wrap">
            <h2 class="title">企业资质</h2>
          </div>
          <div class="message-wrapper">
            <div class="message-left">提示：</div>
            <div class="message-content">
              <p>请确保您充分知悉并符合以下基本条件及说明：</p>
              <p>1.提交的信息真实，证明文件有效。</p>
              <p>2.易派客有权对上传的文件进行不定期抽查，以核实真实性、合法性和效力状态。</p>
              <p>
                3.上传的证书需不侵犯他人知识产权，需按自有资质要求上传，正确的数据，合法的数据，如有法律分险，需自行承担。
              </p>
              <p>4.每一项资质最多上传50个文件，单个文件最大支持20M。</p>
            </div>
          </div>
          <EnterpriseInfo
            ref="enterpriseInfo"
            :tabs="enterpriseInfo.tabsList"
            is-view
            :status="1"
            @getIndex="getIndex"
          ></EnterpriseInfo>
          <div class="message-tips">{{ messages[currentIndex] }}</div>
        </div>

        <div class="store-container">
          <div class="title-wrap">
            <h2 class="title">核心产品</h2>
          </div>
          <Goods :pane-list="enterpriseInfo.paneList"></Goods>
        </div>
      </template>
    </div>
    <div class="handle-btn">
      <!-- <eui-btn @click="save">保存</eui-btn> -->
      <eui-btn :disabled="auditStatus === 1" @click="save">提交审核</eui-btn>
    </div>
  </div>
</template>

<script>
import Api from '@/modules/projectA/api/cms/index';
import { epecMallUrl } from '@/modules/projectA/api/config';
import EnterpriseInfo from './components/enterpriseInfo.vue';
import ProductConfig from './components/productConfig.vue';
import Goods from './components/goods.vue';

import { videoFileUpload, zoneConfigurationImageUpload, headers } from './mixins';

export default {
  components: { EnterpriseInfo, ProductConfig, Goods },
  data() {
    return {
      messages: [
        '提示：经营资质包括营业执照、税务登记证、组织机构代码证。',
        '提示：许可资质：包括生产许可证、特种设备制造许可证、CCC认证、代理商的各种授权书、质量管理体系认证、环境管理体系认证、职业健康安全管理体系认证、知识产权管理体系认证等。',
        '提示：能力资质包括企业获得的由地方、国家、专业机构、行业协会颁发的相应资质证书等；获奖证书、专利等。',
        '提示：其他资质包括供应服务能力（销售业绩、企业产能、生产检验设备、仓储运输能力、研发能力、售后能力等介绍，非证书类）、知识创新能力（专利清单、商标清单、知识产权清单、创新研发介绍等，非证书类）、其他证书。',
      ],
      currentIndex: 0,
      videoFileUpload,
      zoneConfigurationImageUpload,
      headers,

      /* enterpriseInfo: {
        video: {
          enable: true,
          videoFileList: [],
        },
        slides: {
          enable: true,
          slidesFileList: [],
        },
        profile: {
          enable: true,
          enterpriseProfile: `公司简介
            江苏武进不锈股份有限公司，创建于1970年，是国内最大的不锈钢无缝钢管、不锈钢焊接钢管、钢制管件和法兰产品制造商之一，是国家重点高新技术企业。公司占地面积70万平方米，现有员工1400余人。
            不锈钢无缝钢管规格为Φ6～Φ762×0.5～70mm，年产能为4.5万吨；不锈钢焊接钢管规格为Φ15～Φ2200×0.5～80mm，年产能为3.5万吨；钢制管件和法兰年产能为1万吨。
            公司生产设备先进，工艺装备齐全，主要设备有60型～720型系列热轧穿孔机组、LG30～LG720系列冷轧机组、YLB5T～YLB1000T系列高精度液压冷拔机组、大型套孔镗孔机组、电脑自动控制天然气辊底式和箱式炉固溶炉、SG711不锈钢自动焊管机组、各种管件生产机组等。
            公司始终坚持“走精品之路，做品牌企业”的发展方针，实行“让所有顾客满意”的质量目标，配备了国内外先进的检测仪器。拥有超声波探伤机、涡流探伤机、水压试验机、X射线探伤机、直读光谱仪、氮氧分析仪、液压万能试验机、冲击试验机、自动碳硫分析仪、内窥镜等精湛的检测设备，检测手段完善。
            公司产品广泛应用于石油、化工、核电、锅炉、造纸船舶等领域。公司是中石化、中石油、中海油等石化企业及各大锅炉厂的定点供货单位，是东方锅炉集团股份有限公司优质供方，惠生工程（中国）有限公司合格供应商，神华宁煤集团三星级供应商，中核集团，CTCI（台湾中鼎工程股份有限公司）合格供方以及Sabic（沙特基础工业公司）、BHEL、EIL、Sasol、CRCC（巴西国家石油公司）、KOC（科威特石油公司）等单位的合格供方。`,
        },
        vr: {
          enable: true,
          vrUrl: 'https://element.eleme.cn/#/zh-CN/component/switch',
        },
        qualification: {
          enable: true,
          tabsList: [
            {
              label: '经营资质',
              value: 0,
              tableData: [
                {
                  certificateName: '',
                  certificateNumber: '',
                  limit: '',
                  time: [],
                  certificateImg: [{ fileName: '', url: '' }],
                },
              ],
            },
            {
              label: '许可资质',
              value: 1,
              tableData: [
                {
                  certificateName: '',
                  certificateNumber: '',
                  limit: '',
                  time: [],
                  certificateImg: [{ fileName: '', url: '' }],
                },
              ],
            },
            {
              label: '能力资质',
              value: 2,
              tableData: [
                {
                  certificateName: '',
                  certificateNumber: '',
                  limit: '',
                  time: [],
                  certificateImg: [{ fileName: '', url: '' }],
                },
              ],
            },
            {
              label: '其他相关资质',
              value: 3,
              tableData: [
                {
                  certificateName: '',
                  certificateNumber: '',
                  limit: '',
                  time: [],
                  certificateImg: [{ fileName: '', url: '' }],
                },
              ],
            },
          ],
        },
      }, */
      enterpriseInfo: {
        videoFileList: [],
        videoEnable: true,

        slidesFileList: [],
        slidesEnable: true,

        enterpriseProfile: ``,
        enterpriseProfileEnable: true,

        vrUrl: '',
        vrEnable: true,

        qualificationEnable: true,
        tabsList: [
          {
            label: '经营资质',
            value: 0,
            tableData: [
              {
                certificateName: '',
                certificateNumber: '',
                limit: '',
                time: [],
                certificateImg: [{ fileName: '', url: '' }],
              },
            ],
          },
          {
            label: '许可资质',
            value: 1,
            tableData: [
              {
                certificateName: '',
                certificateNumber: '',
                limit: '',
                time: [],
                certificateImg: [{ fileName: '', url: '' }],
              },
            ],
          },
          {
            label: '能力资质',
            value: 2,
            tableData: [
              {
                certificateName: '',
                certificateNumber: '',
                limit: '',
                time: [],
                certificateImg: [{ fileName: '', url: '' }],
              },
            ],
          },
          {
            label: '其他相关资质',
            value: 3,
            tableData: [
              {
                certificateName: '',
                certificateNumber: '',
                limit: '',
                time: [],
                certificateImg: [{ fileName: '', url: '' }],
              },
            ],
          },
        ],

        paneList: [],
      },
      // 1-审核中 2-审核通过 3-审核拒绝 0-初始状态
      auditStatus: 0,
    };
  },
  computed: {},
  watch: {
    auditStatus(newVal) {
      if (newVal === 1) {
        this.getDetailInfoAudit();
      }
    },
  },
  mounted() {
    this.getDetailInfo();
    this.checkAuditStatus();
  },
  methods: {
    getIndex(index) {
      this.currentIndex = index;
    },
    goPath(path) {
      if (path) {
        this.$router.push(path);
        return;
      }
      const { companyId, companyName } = this.$store.state.USERINFO;
      window.open(`${epecMallUrl}/supplier?companyId=${companyId}&companyName=${companyName}&view=0`);
    },
    async getQueryCompanyDetailSup() {
      const { companyId } = this.$store.state.USERINFO;
      const res = await Api.queryCompanyDetailSup({ companyId });
      console.log(res);
      if (res.code === '200') {
        if (!this.enterpriseInfo.enterpriseProfile) {
          this.enterpriseInfo.enterpriseProfile = res.data.companyIntroduction;
        }
      }
    },
    async getDetailInfoAudit() {
      const { companyId } = this.$store.state.USERINFO;
      const result = await Api.auditContent({ companyId });
      if (result.code === '200') {
        const contentTemplate = result.data ? JSON.parse(result.data) : {};
        this.enterpriseInfo = { ...this.enterpriseInfo, ...contentTemplate };
        this.$nextTick(() => {
          this.$refs.scrollbar.update();
        });
        console.log(this.enterpriseInfo, 'this.enterpriseInfo');
      }
    },
    async getDetailInfo() {
      const { companyId } = this.$store.state.USERINFO;
      const result = await Api.getCompanyConfiguration({ companyId });
      if (result.code === '200') {
        const contentTemplate = result.data?.contentTemplate ? JSON.parse(result.data.contentTemplate) : {};
        // 这里提交的时候必须全部变成true
        const itemArr = ['videoEnable', 'slidesEnable', 'enterpriseProfileEnable', 'vrEnable', 'qualificationEnable'];
        itemArr.forEach((item) => {
          contentTemplate[item] = true;
        });
        this.enterpriseInfo = { ...this.enterpriseInfo, ...contentTemplate };
        if (!this.enterpriseInfo.enterpriseProfile) {
          this.getQueryCompanyDetailSup();
        }

        console.log(this.enterpriseInfo, 'this.enterpriseInfo');
      }
    },
    handleParameterImgList(val) {
      console.log(val);
    },
    // 操作人附件上传
    videoSuccess(obj) {
      try {
        if (obj.code === '200') {
          const videoFileList = this.enterpriseInfo.videoFileList.map((item) => {
            item.url = item?.response?.data?.url || item.url;
            item.text = 'video';
            return item;
          });
          this.$message.success('视频上传成功');
          this.enterpriseInfo.videoFileList = videoFileList;
        } else {
          this.$message.error(obj.message);
          this.enterpriseInfo.videoFileList = [];
        }
      } catch (err) {
        this.$message.error('视频上传失败');
        this.enterpriseInfo.videoFileList = [];
      }
    },
    videoError(err, file, fileList) {
      console.log(err, file, fileList);
      this.enterpriseInfo.videoFileList = [];
    },
    slidesSuccess(obj) {
      console.log(obj);
      if (obj.code === '200') {
        const slidesFileList = this.enterpriseInfo.slidesFileList.map((item) => {
          item.url = item?.response?.data?.url || item.url;
          return item;
        });

        this.enterpriseInfo.slidesFileList = slidesFileList;
      } else {
        this.$message.error(obj.message);
      }
    },
    onSetting(val) {
      this.enterpriseInfo.paneList = val;
    },

    async checkAuditStatus() {
      try {
        const { companyId } = this.$store.state.USERINFO;
        const { data = {}, code } = await Api.auditStatus({ companyId });
        if (code === '200') {
          this.auditStatus = data.auditStatus || 0;
        }
      } catch (err) {
        console.log('err:', err);
      }
    },

    async save() {
      function isValidURL(url) {
        // 匹配 http 或 https 开头，随后是域名部分（包括二级域名和顶级域名），允许端口号、路径、查询参数等
        const regex = /^http/;
        return regex.test(url);
      }

      if (this.enterpriseInfo?.vrUrl && !isValidURL(this.enterpriseInfo.vrUrl)) {
        this.$message.warning('VR链接格式错误');
        return;
      }

      const { tabsList } = this.$refs.enterpriseInfo;
      const contentTemplate = JSON.stringify({
        ...this.enterpriseInfo,
        tabsList,
      });

      const result = await Api.submit({ contentTemplate });
      if (result.code === '200') {
        // 提交审核后重置到默认数据
        this.getDetailInfo();
        this.checkAuditStatus();
        this.$message({
          message: '提交审核成功',
          type: 'success',
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.store-title-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  .left-btn-container {
    display: flex;
    align-items: center;
    .store-title {
      font-size: 16px;
      color: #333;
      margin-right: 10px;
    }
  }
}
.store-container {
  min-width: 880px;
  overflow: auto;
  padding: 20px;
  background: #fff;
  margin-bottom: 20px;
  /* ::v-deep .no-upload {
    .el-upload--picture-card {
      display: none;
    }
  } */
  ::v-deep .store-single {
    & > div:nth-of-type(1) {
      display: flex;
      flex-direction: row-reverse;
      justify-content: flex-end;
    }
    .el-upload-list__item,
    .file_cord_item {
      width: 100px;
      height: 100px;
    }
    .file_text_item {
      width: 35%;
    }
    .el-upload-list {
      padding-left: 10px;
    }
    .file_cord_item {
      &:hover {
        .cord_item_btn {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
    .el-upload-list__item {
      border: 1px solid #d9d9d9;
    }
    .upload_cord,
    .el-upload--picture-card {
      width: 100px;
      height: 100px;
    }
    .el-upload--picture-card {
      border: 1px solid #d9d9d9;
    }
  }

  ::v-deep .video-upload {
    .el-upload-list__item {
      width: 500px;
    }
  }
  .title-wrap {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .title {
      margin-right: 8px;
      line-height: 1;
      font-size: 16px;
      color: #333;
    }
    .title-tips {
      display: flex;
      align-items: center;
      cursor: pointer;
      span {
        margin-left: 4px;
        color: #c5c5c5;
        font-size: 12px;
      }
      ::v-deep .el-popover__reference {
        display: flex;
        align-items: center;
      }
    }
  }
  .message-wrapper {
    display: flex;
    margin-bottom: 20px;
    padding: 16px 10px;
    background: #e8efff;
    font-size: 14px;
    color: #333;
    .message-left {
      font-weight: bold;
      color: #f0250f;
      white-space: nowrap;
    }
    p {
      margin-bottom: 2px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
.message-tips {
  margin-top: 10px;
  color: #999;
  font-size: 14px;
}
.handle-btn {
  display: flex;
  justify-content: center;
  min-width: 880px;
}
</style>
